<template>
  <el-tooltip effect="dark" :disabled="disabled"
              :visible-arrow="visibleArrow"
              :placement="placement"
              :popper-class="popperClass"
              :offset="offset"
              :transition="transition"
              :manual="manual"
              :enterable="enterable"
              :hide-after="hideAfter"
              :tabindex="tabindex"
              :open-delay="2000">
    <div slot="content" :style="{maxWidth:validatorContentImg||imgUrl?'fit-content':'250px'}"
         style="display: inline-flex;max-height: 50vh;overflow-y: auto;overflow-x: hidden">
      <img v-if="validatorContentImg||imgUrl" :src="imgUrl?imgUrl:validatorContentImg"
           style="margin-right: 10px;max-width: 600px">
      <div style="max-width: 250px;width: max-content;">{{ validatorContent }}</div>
    </div>
    <slot></slot>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    effect: {
      type: String,
      default: 'effect'
    },
    openDelay: {
      type: Number,
      default: 2000
    },
    content: {
      type: String,
      default: ""
    },
    imgUrl: {
      type: String,
      default: "",
    },
    popperClass: {
      type: String,
      default: ""
    },
    visibleArrow: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    offset: {
      type: Number,
      default: 0
    },
    transition: {
      type: String,
      default: "el-fade-in-linear"
    },
    manual: {
      type: Boolean,
      default: false
    },
    enterable: {
      type: Boolean,
      default: true
    },
    hideAfter: {
      type: Number,
      default: 0
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },
  name: "index",
  data() {
    return {
      validatorContentImg: "",
      validatorContent: ""
    }
  },
  created() {
    let pattern = /<img[^>]*>/g;
    if (this.content) {
      this.validatorContent = this.content.replace(pattern, "");
      let start = this.content.indexOf('<img '); // 找到逗号的位置
      let end = this.content.indexOf(' img>'); // 找到逗号的位置
      if (start !== -1 && end !== -1) {
        this.validatorContentImg = this.content.substring(start + 5, end)
      }
    }

  },
  watch: {
    contentImg(val) {
      if (val) {
        let start = val.indexOf('<img '); // 找到逗号的位置
        let end = val.indexOf(' img>'); // 找到逗号的位置
        if (start !== -1 && end !== -1) {
          this.validatorContentImg = val.substring(start + 5, end)
        }
      }
      this.validatorContentImg = ""
    },
    content(val) {
      if (val) {
        this.validatorContent = val.replace(/<img[^>]*>/g, "")
      } else {
        this.validatorContent = ""
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tooltip/index.vue